class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.headerID = document.querySelector('.shopify-section-header').id.replace('shopify-section-', '')
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items' || event.source === 'gift-wrapping' || event.source === 'product-form' || event.source === 'quick-order-list') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onCartUpdate() {
    const mainCart = document.getElementById('main-cart');
    if (!mainCart) return;

    fetch(`${routes.cart_url}?section_id=${mainCart.dataset.id}`)
      .then((response) => response.text())
      .then((responseText) => {
        const source = new DOMParser().parseFromString(responseText, 'text/html').querySelector('#main-cart');
        if (!source) return;

        const prevScrollTop = window.scrollY;
        mainCart.innerHTML = source.innerHTML;
        afterStableDOM(() => window.scrollTo({ top: prevScrollTop, left: 0, behavior: 'auto' }));
      })
      .catch(e => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    let arraySections = []
    arraySections = [
      {
        id: 'main-cart',
        section: document.getElementById('main-cart').dataset.id,
        selector: 'shopify-section',
      },
      {
        id: `cart-icon-bubble-${this.headerID}`,
        section: this.headerID,
        selector: '.cart-icon-bubble-count'
      }
    ];
    return arraySections
  }

  updateQuantity(line, quantity, name, errorMessage = '') {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);
      const items = this.querySelectorAll('.cart-item');

      if (parsedState.errors) {
        const reason = typeof parsedState.errors === 'string'
          ? parsedState.errors
          : parsedState.description || parsedState.message || window.cartStrings.error;

        fetch(`${routes.cart_url}.js`)
          .then(res => res.json())
          .then(cart => {
            const cartLineItem = cart.items[line - 1];
            const acceptedQuantity = cartLineItem ? cartLineItem.quantity : 0;

            this.updateQuantity(line, acceptedQuantity, name, reason);
          })
          .catch((err) => {
            console.error("Failed to re-fetch cart:", err);
            this.disableLoading(line);
          });
      
        return;
      }

      this.classList.toggle('is-empty', parsedState.item_count === 0);
      const cartDrawerWrapper = document.querySelector('cart-drawer');
      
      if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
      cartDrawerWrapper?.disableStaggerReplay?.();
      
      this.getSectionsToRender().forEach((section => {
        if (document.querySelectorAll(`#${section.id}`)) {
          const elementsToCart = document.querySelectorAll(`#${section.id}`);

          Array.from(elementsToCart).forEach(element => {
            const oldScrollContainer =
              element.querySelector('.cart-drawer__inner-wrapper') || document.scrollingElement;
          
            const prevScrollTop = (oldScrollContainer === document.scrollingElement)
              ? window.scrollY
              : oldScrollContainer.scrollTop;
          
            this.renderSection(element, this.getSectionInnerHTML(parsedState.sections[section.section], `#${section.id}`));

            const cartDrawerScrollContainer = element.querySelector('.cart-drawer__inner-wrapper');

            afterStableDOM(() => {
              const newScrollContainer = cartDrawerScrollContainer || document.scrollingElement;
            
              if (!!cartDrawerScrollContainer) {
                newScrollContainer.scrollTop = prevScrollTop;
              } else {
                window.scrollTo({ top: prevScrollTop, left: 0, behavior: 'auto' });
              }
            }, !!cartDrawerScrollContainer
            );
          });
        }
      }));

      const requestedQuantity = parseInt(quantity);
      const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
      let message = errorMessage;

      if (!message && requestedQuantity > 0 && items.length === parsedState.items.length && updatedValue !== requestedQuantity) {
        typeof updatedValue === 'undefined' ? message = window.cartStrings.error : message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
      }

      this.updateLiveRegions(line, message);

      const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);

      if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
        cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
      } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
        trapFocus(cartDrawerWrapper.querySelector('.cart-drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
      } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
        trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
      }

      publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});
      this.disableLoading(line);
      
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: {
          cart: state
        }
      }))     
    }).catch(() => {
      this.querySelectorAll('.loading-overlay__spinner').forEach((overlay) => overlay.classList.add('hidden'));
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');

      if (errors) {
        errors.textContent = window.cartStrings.error;
        errors.style.marginTop = '16px';
      }
      
      this.disableLoading(line);
    });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);
      setTimeout(() => cartStatus.setAttribute('aria-hidden', true), 1e3);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  renderSection(element, html) {
    const currentRecommendations = element.querySelector('.drawer-recommendations');

    if (!currentRecommendations) {
      element.innerHTML = html;
      return;
    }

    const holder = document.createElement('div');
    holder.innerHTML = html;
    const nextRecommendations = holder.querySelector('.drawer-recommendations');

    if (nextRecommendations && this.isSameRecommendations(currentRecommendations, nextRecommendations)) {
      nextRecommendations.replaceWith(currentRecommendations);
    }

    element.replaceChildren(...holder.childNodes);
  }

  isSameRecommendations(current, next) {
    const url = (element) => element.querySelector('product-recommendations')?.dataset.url || '';

    return url(current) === url(next);
  }

  enableLoading(line) {
    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}
customElements.define('cart-items', CartItems);

class CartDrawerItems extends CartItems {
  constructor() {
    super();

    this.cartDrawerID = document.querySelector('.shopify-section-cart-drawer').id.replace('shopify-section-', '')
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=${this.cartDrawerID}`)
      .then((response) => response.text())
      .then((responseText) => {
        const source = new DOMParser().parseFromString(responseText, 'text/html').querySelector('cart-drawer-items');
        if (!source) return;

        this.closest('cart-drawer')?.disableStaggerReplay?.();
        this.innerHTML = source.innerHTML;
      })
      .catch(e => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    let arraySections = []
    arraySections = [
      {
        id: 'CartDrawer',
        section: this.cartDrawerID,
        selector: '.cart-drawer__inner'
      },
      {
        id: `cart-icon-bubble-${this.headerID}`,
        section: this.headerID,
        selector: '.cart-icon-bubble-count'
      }
    ];
    return arraySections
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);

class ShippingCalculator extends HTMLElement {
  constructor() {
    super();

    this.setupCountries();
    
    this.errors = this.querySelector('#ShippingCalculatorErrors');
    this.success = this.querySelector('#ShippingCalculatorSuccess');
    this.zip = this.querySelector('#ShippingCalculatorZip');
    this.country = this.querySelector('#ShippingCalculatorCountry');
    this.province = this.querySelector('#ShippingCalculatorProvince');
    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.onSubmitHandler.bind(this));
  }

  setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('ShippingCalculatorCountry', 'ShippingCalculatorProvince', {
        hideElement: 'ShippingCalculatorProvinceContainer'
      });
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();
    
    this.errors.classList.add('hidden');
    this.success.classList.add('hidden');
    this.zip.classList.remove('invalid');
    this.country.classList.remove('invalid');
    this.province.classList.remove('invalid');
    this.button.classList.add('loading');
    this.button.setAttribute('disabled', true);
    const body = JSON.stringify({
      shipping_address: {
        zip: this.zip.value,
        country: this.country.value,
        province: this.province.value
      }
    });
    let sectionUrl = `${routes.cart_url}/shipping_rates.json`;

    // remove double `/` in case shop might have /en or language in URL
    sectionUrl = sectionUrl.replace('//', '/');

    fetch(sectionUrl, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates) {
          this.success.classList.remove('hidden');
          this.success.innerHTML = '';
          
          parsedState.shipping_rates.forEach((rate) => {
            const child = document.createElement('p');
            child.innerHTML = `${rate.name}: ${rate.price} ${Shopify.currency.active}`;
            this.success.appendChild(child);
          });
        }
        else {
          let errors = [];
          Object.entries(parsedState).forEach(([attribute, messages]) => {
            errors.push(messages[0]);
          });

          this.errors.classList.remove('hidden');
          this.errors.querySelector('.errors').innerHTML = errors.join('; ');
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.button.classList.remove('loading');
        this.button.removeAttribute('disabled');
        if(this.closest('.accordion__panel')) {
          let offset = 0
          if(this.success && !this.success.className.includes('hidden')) offset = this.success.offsetHeight
          if(this.errors && !this.errors.className.includes('hidden')) offset = this.errors.offsetHeight
          this.closest('.accordion__panel').style.maxHeight = this.closest('.accordion__panel').offsetHeight + offset + 'px'
        }
      });
  }
}

customElements.define('shipping-calculator', ShippingCalculator);


function formatMoney(cents) {
  let formatted = new Intl.NumberFormat(Shopify.currency.active, {
      style: 'currency',
      currency: Shopify.currency.active
  }).format(cents / 100);

  formatted = formatted.replace(/[A-Za-z\s]+/g, '').trim();

  return formatted;
}

function afterStableDOM(callback, doubleRAF = false) {
  if (typeof callback !== 'function') {
    throw new TypeError('afterStableDOM expects a function');
  }

  queueMicrotask(() => {
    requestAnimationFrame(() => {
      if (doubleRAF) {
        requestAnimationFrame(callback);
      } else {
        callback();
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  function updateFreeShippingBars() {
    const freeShippingElements = document.querySelectorAll('.free-shipping');
      if (freeShippingElements.length === 0) return;

      freeShippingElements.forEach(freeShippingElement => {
          let threshold = parseFloat(freeShippingElement.dataset.freeShippingAmount) * 100;
          let cartTotal = parseFloat(freeShippingElement.dataset.cartTotal);
          let currencyRate = Shopify.currency.rate || 1;

          let convertedThreshold = Math.round(threshold * currencyRate);

          let freeShippingMessage = freeShippingElement.dataset.freeShippingMessage || "Spend {{ remaining_amount }} more for free shipping!";
          let freeShippingSuccess = freeShippingElement.dataset.freeShippingSuccess || "You've unlocked free shipping!";

          let remainingAmount = Math.max(0, convertedThreshold - cartTotal);

          const progressBar = freeShippingElement.querySelector('.free-shipping__progress');
          const textElement = freeShippingElement.querySelector('.free-shipping__text');

          if (cartTotal >= convertedThreshold) {
              textElement.innerHTML = `${freeShippingSuccess}`;
              progressBar.style.setProperty("--progress", "100%");
              progressBar.classList.add('free-shipping__progress--success');
          } else {
              textElement.innerHTML = `${freeShippingMessage.replace("{{ remaining_amount }}", formatMoney(remainingAmount))}`;
              let progressPercent = Math.min(100, (cartTotal / convertedThreshold) * 100);
              progressBar.style.setProperty("--progress", `${progressPercent}%`);
              progressBar.classList.remove('free-shipping__progress--success');
          }
      });
  }

  updateFreeShippingBars();
});

if (!customElements.get('cart-attribute')) {
  customElements.define(
    'cart-attribute',
    class CartAttribute extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            this.update(event.target.value);
          }, 300)
        );
      }

      connectedCallback() {
        if (this.hasAttribute('data-clear')) this.update('');
      }

      update(value) {
        const attribute = this.dataset.attribute;
        const body = JSON.stringify(attribute ? { attributes: { [attribute]: value } } : { note: value });
        return fetch(`${window.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }
    }
  );
}

class GiftWrapping extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.checkbox = this.querySelector('.gift-wrapping__checkbox');
    if (!this.checkbox) return;

    this.initialized = true;
    this.spinner = this.querySelector('.gift-wrapping__spinner');
    this.errorElement = this.querySelector('.gift-wrapping__error');

    this.onChange = this.onChange.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.onQuickViewClose = this.onQuickViewClose.bind(this);

    this.addEventListener('change', this.onChange);
    this.addEventListener('keydown', this.onKeydown);
    document.addEventListener('quickview:close', this.onQuickViewClose);

    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (!this.awaitingQuickView || event.source !== 'product-form') return;

      this.awaitingQuickView = false;
      document.querySelector('body > quick-view-drawer quick-view')?.closeQuickView();
      setTimeout(() => document.body.classList.remove('gift-wrapping-adding'));
    });
  }

  disconnectedCallback() {
    if (this.onQuickViewClose) document.removeEventListener('quickview:close', this.onQuickViewClose);
    if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
  }

  onChange(event) {
    event.stopPropagation();
    if (this.loading) return;

    this.checkbox.checked ? this.addGiftWrapping() : this.removeGiftWrapping();
  }

  onKeydown(event) {
    if (event.key === 'Enter' && event.target === this.checkbox) event.preventDefault();
  }

  get cartItems() {
    return this.closest('cart-drawer')
      ? document.querySelector('cart-drawer-items')
      : document.querySelector('cart-items');
  }

  getSectionsToRender() {
    const sections = new Map();

    document.querySelectorAll('cart-items, cart-drawer-items').forEach((cartItems) => {
      cartItems.getSectionsToRender().forEach((section) => sections.set(section.id, section));
    });

    return Array.from(sections.values());
  }

  addGiftWrapping() {
    if (!this.dataset.variantId) {
      this.openQuickView();
      return;
    }

    const sections = this.getSectionsToRender();
    const body = JSON.stringify({
      id: this.dataset.variantId,
      quantity: 1,
      sections: sections.map((section) => section.section),
      sections_url: window.location.pathname
    });

    this.setLoading(true);

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.status) {
          this.handleError(parsedState.description || parsedState.message);
          return;
        }
        this.renderSections(parsedState, sections);
      })
      .catch(() => {
        this.handleError();
      })
      .finally(() => {
        this.setLoading(false);
      });
  }

  removeGiftWrapping() {
    const giftMessage = document.querySelector('cart-attribute.gift-message__field');
    const removeLine = () => this.cartItems.updateQuantity(this.dataset.lineIndex, 0);

    if (!giftMessage) {
      removeLine();
      return;
    }

    giftMessage.update('').catch(() => {}).then(removeLine);
  }

  openQuickView() {
    const quickViewDrawer = document.querySelector('body > quick-view-drawer');

    if (!quickViewDrawer) {
      window.location = this.dataset.productUrl;
      return;
    }

    this.awaitingQuickView = true;
    const fromCartDrawer = this.closest('cart-drawer') !== null;

    document.body.classList.add('hidden', 'quick-view-open', 'gift-wrapping-adding');
    if (fromCartDrawer) removeTrapFocus();

    quickViewDrawer.setAttribute('data-loading', '');
    quickViewDrawer.toggleAttribute('data-from-cart-drawer', fromCartDrawer);
    quickViewDrawer.querySelector('quick-view').setAttribute('data-product-url', this.dataset.productVariantUrl);
    quickViewDrawer.querySelector('summary').click();

    document.dispatchEvent(new CustomEvent('quickview:open', {
      detail: {
        productUrl: this.dataset.productUrl
      }
    }));
  }

  onQuickViewClose() {
    const cartDrawer = this.closest('cart-drawer');
    const keepDrawerOpen = cartDrawer !== null && cartDrawer.classList.contains('open');

    if (keepDrawerOpen) document.body.classList.add('hidden', 'overlay-opened');

    if (!this.awaitingQuickView) return;
    this.awaitingQuickView = false;

    document.body.classList.remove('gift-wrapping-adding');
    this.checkbox.checked = false;
    if (keepDrawerOpen) trapFocus(cartDrawer, this.checkbox);
  }

  renderSections(parsedState, sections) {
    if (!parsedState || !parsedState.sections) return;

    sections.forEach((section) => {
      const html = parsedState.sections[section.section];
      if (!html) return;

      const source = new DOMParser().parseFromString(html, 'text/html').querySelector(`#${section.id}`);
      if (!source) return;

      document.querySelectorAll(`#${section.id}`).forEach((element) => {
        element.innerHTML = source.innerHTML;
      });
    });

    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift-wrapping' });
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  setLoading(state) {
    this.loading = state;
    this.classList.toggle('gift-wrapping--loading', state);
    this.checkbox.disabled = state;
    if (this.spinner) this.spinner.classList.toggle('hidden', !state);
    if (state && this.errorElement) this.errorElement.textContent = '';
  }

  handleError(message) {
    this.checkbox.checked = !this.checkbox.checked;
    if (this.errorElement) this.errorElement.textContent = message || window.cartStrings.error;
  }
}

customElements.define('gift-wrapping', GiftWrapping);